import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { setPermission, setUser } from "../store/actions";
import Loading from "../component/Loading";

import AuthService from "../service/auth";
import Permission from "../service/permissions";

//Protected Route
//Only allow components access if user is logged in
const PrivateRoute = ({ moduleName, children }) => {
  const { user, permissions } = useSelector((state) => state);
  const [loading, setLoading] = useState(true);

  const dispatch = useRef(useDispatch());
  const navigate = useRef(useNavigate());
  const currentUserRef = useRef(user.currentUser);

  const role = user.currentUser?.Role_id;

  const getPermissions = useCallback(async () => {
    const permission = new Permission();
    const resPermission = await permission.init();

    dispatch.current(setPermission(resPermission.data));
  }, []);

  const getAuthUser = useCallback(async () => {
    const authService = new AuthService();

    if (currentUserRef.current) {
      await getPermissions();
      setLoading(false);
    } else {
      const response = await authService.getAuthUser();

      if (response.success) {
        await getPermissions();

        dispatch.current(setUser(response.data));
        setLoading(false);
      } else navigate.current((user.currentUser && (user.currentUser.isAdminOrEmp === 1 || role === 4)) ? "/admin" : "/");
    }
  }, [getPermissions]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      await getAuthUser();
    })();
  }, [getAuthUser]);

  if (user.isLoading || loading) return <Loading />;

  //Checking if user is there and user has permission for that module or its OPEN
  return user.currentUser && (moduleName === "OPEN" || permissions.includes(moduleName)) ? (
    children
  ) : (
    (user.currentUser && (user.currentUser.isAdminOrEmp === 1 || role === 4)) ? <Navigate to="/admin" /> : <Navigate to="/" />
  );
};

export default PrivateRoute;
